import React, { SyntheticEvent } from "react";
import { Updater } from "use-immer";

import { IgBadge, IgTab, IgTabs, IgTypography } from "@intelligems/ig-theme";
import { StandardEventAllowedKeyMetrics } from "@intelligems/ig-types";
import Grid from "@mui/material/Grid";

interface KeyMetricsDrawerTabsProps {
  tabValue: number;
  setTabValue: Updater<number>;
  selectedStandardMetrics: StandardEventAllowedKeyMetrics[];
  selectedCustomEventIds: string[];
}

export const KeyMetricsDrawerTabs = ({
  tabValue,
  selectedStandardMetrics,
  selectedCustomEventIds,
  setTabValue,
}: KeyMetricsDrawerTabsProps) => {
  const onChange = (event: SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Grid flex={1}>
      <IgTabs
        centered={false}
        value={tabValue}
        onChange={onChange}
        aria-label={`Key Metrics Drawer Tabs`}
        sx={{ height: "55px" }}
      >
        <IgTab
          icon={
            <IgBadge
              color={"accent"}
              badgeContent={selectedStandardMetrics.length}
            />
          }
          iconPosition={"end"}
          sx={{
            paddingLeft: "0px !important",
          }}
          label={
            <IgTypography
              sx={{
                fontWeight: tabValue === 0 ? 600 : 400,
                marginRight: "10px",
              }}
            >
              Standard Metrics
            </IgTypography>
          }
        />
        <IgTab
          icon={
            <IgBadge
              color={"accent"}
              badgeContent={selectedCustomEventIds.length}
            />
          }
          iconPosition={"end"}
          label={
            <IgTypography
              sx={{
                fontWeight: tabValue === 1 ? 600 : 400,
                marginRight: "10px",
              }}
            >
              Custom Metrics
            </IgTypography>
          }
        />
      </IgTabs>
    </Grid>
  );
};
